import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import DataTable from "react-data-table-component";
import { useAuth } from "../AuthContext";
import axios from "axios";
import iziToast from "izitoast";
import Footer from "./Footer";
import moment, { min } from "moment";
import { useSocket } from "../SocketContext";

export const TrackExam = () => {
    const { apipath, logout, goBack, token } = useAuth();
    const navigate = useNavigate();
    const { examLiveStats } = useSocket();

    // const token = localStorage.getItem('token');
    const [tests, setTests] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [filters, setFilters] = useState('');
    const schid = localStorage.getItem('sch_id');


    const [isOpen, setIsOpen] = useState(false);
    const [selectedTest, setSelectedTest] = useState('');
    const [file, setFile] = useState(null);
    const togglePopup = () => setIsOpen(!isOpen);
    // localStorage.removeItem('answers');

    const handleFilterChange = (e) => {
        const { value } = e.target;
        setFilters(value);
    }

    const applyFilters = () => {
        // console.log(filters);
        let filteredItems = [...tests];
        const filterValue = filters.toLowerCase();
        if (filterValue) {
            filteredItems = filteredItems.filter(item => {
                return Object.values(item).some(val =>
                    typeof val === 'string' && val.toLowerCase().includes(filterValue)
                );
            });
        }
        setFilteredData(filteredItems);
    }
    useEffect(() => {
        applyFilters();
    }, [filters]);

    const getTests = async () => {
        setIsLoading(true);
        try {
            const response = await axios.post(
                apipath + '/live_exams',
                { 'id': schid },
                {
                    headers: {
                        Authorization: 'Bearer ' + token
                    }
                }
            );
            console.log(response.data);
            if (response.data.status === "unauthentic") {
                iziToast.error({
                    message: response.data.message,
                    position: "topCenter"
                });
                logout();
            }
            if (response.data.status === "false") {
                iziToast.error({
                    message: response.data.message,
                    position: "topCenter"
                });
                return false;
            }
            setTests(response.data.tests);
            setFilteredData(response.data.tests);
        }
        catch (error) {
            // console.error('Error fetching data:', error);
            if (error.status === 401) {
                iziToast.error({
                    message: "Un-Authorised! Please Login.",
                    position: "topCenter"
                });
                logout();
            }
            else {
                iziToast.error({
                    message: error,
                    position: 'topCenter'
                });
            }

        } finally {
            setIsLoading(false);
        }
    }
    useEffect(() => {
        getTests();
    }, []);

    function formatTime(totalSeconds) {
        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;
        const ftime = `${hours}h ${minutes}m ${seconds}s`;

        return ftime;
    }

    const columns = [
        { name: "Name", selector: (row) => row.user?.name, sortable: true, },
        { name: "Roll No", selector: (row) => row.user?.roll_no, sortable: true, width: "100px" },
        { name: "Organization", selector: (row) => row.user?.organization?.name, sortable: true, },
        { name: "Exam", selector: (row) => row.user?.exam?.exam_name, sortable: true, },
        { name: "Test", selector: (row) => row.test?.test?.test_name, sortable: true, },
        { name: "Time", selector: (row) => row.test?.test?.duration, sortable: true, width: '75px' },
        { name: "Start Time", selector: (row) => moment(row.start_time).format("YYYY-MM-DD HH:mm"), sortable: true, width: "140px" },
        { name: "Started At", selector: (row) => row.started_at ? moment(row.started_at).format("YYYY-MM-DD HH:mm") : "", sortable: true, width: "140px" },
        { name: "Submitted At", selector: (row) => row.submitted_at ? moment(row.submitted_at).format("YYYY-MM-DD HH:mm") : "", sortable: true, width: "140px" },
        { name: "Time Left", selector: (row) => formatTime(row.time_left), sortable: true, },
        {
            name: "Status", selector: (row) => <button className="border rounded p-1">{row.status}</button>, sortable: true, width: '100px'
        },
    ];

    return (
        <>
            <span className={(isLoading) ? "flex items-center text-white bg-gray-400/75 justify-center fixed top-0 left-0 w-full h-screen z-50" : "hidden"}>
                <svg
                    className="w-5 h-5 mr-2 animate-spin"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                >
                    <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                    ></circle>
                    <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8v4l3-3-3-3V4a10 10 0 1010 10h-4l3 3 3-3h-4a8 8 0 01-8 8z"
                    ></path>
                </svg>
            </span>
            {<Navbar />}
            <div class="flex flex-col md:flex-row">
                {<Sidebar activePage={"schedules"} />}
                <div class="main-content flex-1 bg-gray-100 pb-24 md:pb-5 w-full md:w-4/5 lg:w-5/6 pt-16 md:pt-8">

                    <div class="bg-teal-700 pt-4">
                        <div class="rounded-tl-3xl bg-teal-600 p-2 justify-between shadow text-2xl text-white flex flex-col md:flex-row relative">
                            <span class="font-bold pl-2">
                                <i className="fa fa-arrow-left text-sm border-2 rounded absolute right-3 py-1 px-2 top-2 bg-teal-700 hover:bg-teal-800 cursor-pointer" title="go back" onClick={() => goBack()}></i>Students Exam Status</span>
                            {/* <div className="flex flex-row mt-4 md:mt-0">
                                <Link to={`/exams`}><span class={`md:ml-5 ml-2 ${activeTab === 'Exam' ? 'bg-teal-800 border-transparent' : 'bg-transparent border-white'} hover:bg-teal-900 text-white font-medium text-base py-1 px-4 border hover:border-transparent rounded`}>
                                    Exams
                                </span></Link>
                                <Link to={`/tests`}><span class={`md:ml-5 ml-2 ${activeTab === 'Test' ? 'bg-teal-800 border-transparent' : 'bg-transparent border-white'} hover:bg-teal-900 text-white font-medium text-base py-1 px-4 border hover:border-transparent rounded`}>
                                    Tests
                                </span></Link>
                            </div> */}
                        </div>
                    </div>

                    <div class="flex flex-wrap">
                        <div class="w-full p-2">
                            {/* <h3 class="mb-3 font-semibold">Exams</h3> */}
                            <div className="flex flex-row items-center justify-between mb-3">
                                <input
                                    type="text"
                                    placeholder="Search..."
                                    value={filters}
                                    onChange={(e) => setFilters(e.target.value)}
                                    className="p-1.5 shadow-[0_0_3px_1px_rgba(155,155,155,0.7)]"
                                />
                                <div className="flex justify-end">
                                    <p className="me-2 font-medium py-1 px-2 border-2 rounded text-white bg-teal-600">Logged In : {examLiveStats.totalLoggedIn}</p>
                                    <p className="me-2 font-medium py-1 px-2 border-2 rounded text-white bg-teal-600">Active : {examLiveStats.active}</p>
                                    <p className="me-2 font-medium py-1 px-2 border-2 rounded text-white bg-teal-600">Re Logged : {examLiveStats.relogged}</p>
                                    <p className="me-2 font-medium py-1 px-2 border-2 rounded text-white bg-teal-600">Started : {examLiveStats.started}</p>
                                    <p className="me-2 font-medium py-1 px-2 border-2 rounded text-white bg-teal-600">Submitted : {examLiveStats.submitted}</p>
                                </div>
                                {/* <div className="flex">
                                    <Link to={`/add_test`}><button className="p-1 text-sm font-bold text-teal-800 rounded-lg border-2 border-teal-800 hover:bg-teal-800 hover:text-white hover:border-transparent">
                                        + Add
                                    </button>
                                    </Link>
                                    <button onClick={togglePopup} className="p-1 ms-3 text-sm font-bold text-green-700 rounded-lg border-2 border-green-700 hover:bg-green-700 hover:text-white hover:border-transparent">
                                        Import Questions
                                    </button>
                                </div> */}
                            </div>
                            <div className="max-h-[70vh] overflow-auto shadow-[0_0_3px_1px_rgba(155,155,155,0.7)]">

                                {/* Data Table */}
                                <DataTable
                                    columns={columns}
                                    data={filteredData}
                                    pagination
                                    highlightOnHover
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};